module.exports = __webpack_public_path__ + "img/about-9.ee92e92b.png";